module.exports = __webpack_public_path__ + "static/media/sur_platea.106d591f.jpg";